import { FunctionFactory } from "survey-core";
import { Gender } from "./gender";

enum Physiology {
  Male = "Male Physiology",
  Female = "Female Physiology",
}


const physiologyQuestion = {
  name: "physiology",
  title: `Which physiology would you like your plan based on?`,
  description: `Aspects of your plan are based on physical traits typically associated with male or female bodies. <br /><br />We're working on more inclusive options. Thanks for your understanding.`,
  descriptionLocation: 'underTitle',
  type: "radiogroup",
  choices: Object.values(Physiology),
  isRequired: true,
  visibleIf: `{gender} == "${Gender.NonBinary}"`,
};

// const genderNounExpression = {
//   name: "genderNoun",
//   expression: "renderGender({gender})",
// };

// function renderGender(params: any[]): string {
//   if (params === undefined || params === null) return "";
//   return (params[0] as Gender) === Gender.Female ? "women" : "men";
// }

//FunctionFactory.Instance.register("renderGender", renderGender);

export { Physiology, physiologyQuestion };
